import React from "react";

const SwiperCardSkeleton = () => {
  return (
    <div 
      className="w-[200px] h-[250px] lg:w-[250px] lg:h-[320px] 2xl:w-[270px] 2xl:h-[340px] rounded-xl group/main relative cursor-pointer m-[1.125rem] animate-pulse"
    >
      {/* Background image skeleton */}
      <div className="h-full w-full bg-gray-200 rounded-xl"></div>
      
      {/* Overlay content skeleton - positioned absolutely on top of card */}
      <div className="absolute inset-0 z-10 flex flex-col justify-between p-2">
        {/* Top section - Pro badge area */}
        {/* <div className="flex items-center justify-end">
          <div className="w-8 h-4 bg-gray-300 rounded"></div>
        </div> */}
        
        {/* Bottom section - Profile and title */}
        {/* <div className="flex gap-x-3 cursor-pointer mb-2"> */}
          {/* Profile picture skeleton */}
          {/* <div className="group/profile relative shrink-0">
            <div className="size-6 rounded-full bg-gray-300"></div>
          </div> */}
          
          {/* Title skeleton */}
          <div className="flex flex-col flex-1 min-w-0 justify-end mb-2">
            <div className="w-full h-4 bg-gray-300 rounded mb-1"></div>
            <div className="w-3/4 h-3 bg-gray-300 rounded"></div>
          </div>
        {/* </div> */}
      </div>
    </div>
  );
};

// Component to render 2 rows of skeleton cards
const SwiperCardSkeletonGrid = () => {
  return (
    <div className="flex flex-col gap-4">
      {/* First row */}
      <div className="flex">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={`skeleton-row1-${index}`} className="sliderImg">
            <SwiperCardSkeleton />
          </div>
        ))}
      </div>
      
      {/* Second row */}
      <div className="flex">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={`skeleton-row2-${index}`} className="sliderImg">
            <SwiperCardSkeleton />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SwiperCardSkeleton;
export { SwiperCardSkeletonGrid }; 